export const autoAppendS = (noun: string, count: number) => (count > 1 ? `${noun}s` : noun)

export const formatToUSD = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(value)
}
